import { GetStaticProps } from "next";
import { VFC } from "react";
import { useTranslation } from "~/hooks";
import { SEO, PageHeader } from "~/components";
import { ArticleList } from "~/layouts";
import { fetchNews, News } from "~/lib/server/microcms";

type Props = {
  news: News[];
  hasNext: boolean;
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const news = await fetchNews(0, 11);
  const hasNext = news.length > 10;
  return {
    props: {
      news: news.filter((_, i) => i < 10),
      hasNext
    },
    revalidate: 60
  };
};

const NewsListPage: VFC<Props> = ({ news, hasNext }) => {
  const { dic } = useTranslation();

  return (
    <ArticleList>
      <SEO pageName="ニュース" path="/news" />
      <PageHeader
        labelText="News"
        headingText={dic.navigation.news}
        crumbs={[
          {
            label: dic.homepage,
            path: "/"
          },
          {
            label: dic.navigation.news
          }
        ]}
      />
      <ArticleList.News
        items={news}
        hasPrev={false}
        hasNext={hasNext}
        page={1}
      />
    </ArticleList>
  );
};

export default NewsListPage;
